<template>
  <div class="aboutE">
    <p class="about-title">{{ title }}</p>
    <div class="about">
      <div class="about-left about-item">
        <img class="cover" :src="imgUrl" alt="封面" />
        <!--不需要播放视频-->
        <!--                    <img-->
        <!--                        class="play-icon"-->
        <!--                        src="https://www.esign.cn/images/play-icon.png"-->
        <!--                        alt="播放图标"-->
        <!--                        @click="startVideo()"-->
        <!--                    />-->
      </div>
      <div class="about-right about-item">
        <div v-for="item in desc" :key="item" class="desc-item">
          <div>{{ item }}</div>
        </div>
      </div>
      <!--video容器-->
      <!--                <div v-show="showVideo" class="video-wrapper">-->
      <!--                    <div class="mask" @click="closeVideo()"></div>-->
      <!--                    <div class="inner">-->
      <!--                        <i class="el-icon-close icon-guanbi iconfont" @click="closeVideo()"></i>-->
      <!--                        <video-->
      <!--                            ref="video"-->
      <!--                            src="https://www.esign.cn/mp3/jseqb.mp4"-->
      <!--                            autoplay-->
      <!--                            controls-->
      <!--                            x5-playsinline-->
      <!--                            playsinline-->
      <!--                            webkit-playsinline-->
      <!--                        ></video>-->
      <!--                    </div>-->
      <!--                </div>-->
    </div>
  </div></template
>

<script>
export default {
  props: {
    // 顶部标题
    title: String,
    // 右侧图片
    imgUrl: String,
    // 右侧文字描述
    desc: Array,
  },
  data() {
    return {}
  },
}
</script>

<style lang="less" scoped>
.aboutE {
  width: 100%;
  max-width: 1320px;
  height: 680px;
  .about-title {
    padding: 72px 0;
    font-size: 32px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.85);
    line-height: 45px;
    text-align: center;
  }
  .about {
    width: 100%;
    max-width: 1320px;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .about-left {
      flex: 0 0 49%;
      height: 400px;
      position: relative;
      .cover {
        width: 100%;
        height: 390px;
      }
      .play-icon {
        position: absolute;
        left: 40%;
        top: 40%;
        cursor: pointer;
        transition: top 0.5s linear; /* 在非:hover状态下设置过渡动画 */
      }
      .play-icon:hover {
        top: 35%;
        transition: all 0.5s linear;
      }
    }
    .about-right {
      flex: 0 0 49%;
      height: 400px;
      padding-top: 12px;
      border-top: 6px solid #f31515; /* 设置一个基础的边框 */
      .desc-item {
        color: #000000;
        font-size: 13px;
        box-sizing: border-box;
        line-height: 24px;
        font-family: -apple-system, BlinkMacSystemFont, 'SF Pro SC', 'SF Pro Text', 'Helvetica Neue', Helvetica, 'PingFang SC', 'Segoe UI',
          Roboto, 'Hiragino Sans GB', arial, 'microsoft yahei ui', 'Microsoft YaHei', SimSun, sans-serif;
        font-weight: 400;
        padding-bottom: 14px;
      }
    }
    .video-wrapper {
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 9999999;
      .mask {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background-color: rgba(0, 0, 0, 0.8); /* 半透明的黑色背景 */
      }
      .inner {
        width: 80vw;
        height: 80vh;
        z-index: 333;
        video {
          width: 80vw;
          height: 80vh;
        }
        .icon-guanbi {
          font-size: 24px;
          color: #fff;
          position: absolute;
          width: 32px;
          height: 32px;
          border-radius: 8px;
          background: rgba(0, 0, 0, 0.45);
          cursor: pointer;
          padding: 4px;
          top: 6px;
          right: 6px;
          z-index: 10;
        }
      }
    }
  }
}
@media (max-width: 1300px) {
  .cover {
    height: 420px !important;
  }
}
@media (max-width: 1172px) {
  .aboutE {
    height: 720px !important;
  }
  .cover {
    height: 450px !important;
  }
}
@media (max-width: 1000px) {
  .aboutE {
    height: 1100px !important;
  }
  .about-item {
    flex: 0 0 100% !important; /* 在1100px以下的宽度，元素占据100%的宽度，变成一行一个元素 */
  }
  .cover {
    height: 400px !important;
  }
}
</style>
